import { adPlacementKey } from '../actions/adActions';

export const selectAdPlacementList = (state, page, placement, scope = '') =>
  state.ads.placements[adPlacementKey(page, placement, scope)] || [];

export const selectAdPlacementFirst = (state, page, placement, scope = '') =>
  selectAdPlacementList(state, page, placement, scope)[0] || null;
